import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../services/UINotificationService";
import { useSetMembershipsObOrderMutation } from "../../../../../api/mutations/useSetMembershipsObOrderMutation";

export function useSaveOrder({ onSuccess }) {
  const { tSettings } = useAppTranslation.Settings();

  const { isLoading, mutate } = useSetMembershipsObOrderMutation({
    onSuccess: () => {
      uiNotification.success(tSettings("memberships.obOrder.success.update"));
      onSuccess();
    },
    onError: () => {
      uiNotification.error(tSettings("memberships.obOrder.error.update"));
    },
  });

  const save = (orderedMemberships) => {
    mutate({
      membershipIds: orderedMemberships.map((membership) => membership.id),
    });
  };

  return {
    save,
    isSaving: isLoading,
  };
}
